import React, { useState } from 'react';

interface ExplanationPanelProps {
  title: string;
  content: string;
  actionGuidance?: string;
  isExpanded?: boolean;
  className?: string;
}

const ExplanationPanel: React.FC<ExplanationPanelProps> = ({
  title,
  content,
  actionGuidance,
  isExpanded = false,
  className = ""
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg ${className}`}>
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full px-4 py-3 text-left flex items-center justify-between hover:bg-blue-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
      >
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 text-blue-600" viewBox="0 0 24 24" fill="currentColor">
            <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h2v-2h-2v2zm0-4h2V8h-2v5z"/>
          </svg>
          <span className="font-medium text-blue-900">{title}</span>
        </div>
        <svg 
          className={`w-5 h-5 text-blue-600 transition-transform duration-200 ${expanded ? 'transform rotate-180' : ''}`}
          viewBox="0 0 24 24" 
          fill="currentColor"
        >
          <path d="M7.41 8.84L12 13.42l4.59-4.58L18 10.25l-6 6-6-6z"/>
        </svg>
      </button>
      
      {expanded && (
        <div className="px-4 pb-4 border-t border-blue-200">
          <div className="pt-3">
            <div className="text-sm text-blue-800 leading-relaxed mb-3">
              {content.split('\n').map((paragraph, index) => (
                <p key={index} className={index > 0 ? 'mt-2' : ''}>
                  {paragraph}
                </p>
              ))}
            </div>
            
            {actionGuidance && (
              <div className="bg-blue-100 rounded-lg p-3 border border-blue-200">
                <div className="flex items-start gap-2">
                  <svg className="w-4 h-4 text-blue-700 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <div>
                    <div className="font-medium text-blue-900 text-sm mb-1">What should you do?</div>
                    <div className="text-sm text-blue-800 leading-relaxed">
                      {actionGuidance.split('\n').map((paragraph, index) => (
                        <p key={index} className={index > 0 ? 'mt-2' : ''}>
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExplanationPanel;